module.exports = __webpack_public_path__ + "static/4_2_recommendation_LV-79354d4bc79a41c62d7b6c4895851c2e.svg";